import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";

const Home = lazy(() => import("../Pages/Home"));
const About = lazy(() => import("../Pages/About"));
const Services = lazy(() => import("../Pages/Services"));
const Markets = lazy(() => import("../Pages/Markets"));
const News = lazy(() => import("../Pages/News"));
const NewsDetail = lazy(() => import("../Pages/NewsDetail"));
const Careers = lazy(() => import("../Pages/Careers"));
const CareersDetail = lazy(() => import("../Pages/CareersDetail"));
const Contact = lazy(() => import("../Pages/Contact"));
const CookiePolicy = lazy(() => import("../Pages/CookiePolicy"));
const Demo = lazy(() => import("../Sections/Demo"));

const MainRoutes = () => {
  return (
    <Suspense>
      <Routes>
        <Route path="*" element={<Home />} />
        <Route path="/about/:section?" element={<About />} />
        <Route path="/services/:service?" element={<Services />} />
        <Route path="/markets/:market?" element={<Markets />} />
        <Route path="/news" element={<News />} />
        <Route path="/news/:id" element={<NewsDetail />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/careers/:id" element={<CareersDetail />} />
        {/* <Route path="/careers/testimonials" element={<Testimonials />} /> */}
        <Route path="/contact" element={<Contact />} />
        {process.env.NODE_ENV === "development" ? (
          <Route path="/demo" element={<Demo />} />
        ) : null}
        <Route path="/cookiepolicy" element={<CookiePolicy />} />
      </Routes>
    </Suspense>
  );
};

export default MainRoutes;
